export const menuConsts = {
  GET_MENU_LIST: "GET_MENU_LIST",
  CREATE_MENU: "CREATE_MENU",
  UPDATE_MENU_ITEMS_POSITION: "UPDATE_MENU_ITEMS_POSITION",
  GET_MENU_BY_ID: "GET_MENU_BY_ID",
  UPDATE_MENU_BY_ID: "UPDATE_MENU_BY_ID",
  DELETE_MENU_BY_ID: "DELETE_MENU_BY_ID",
};